module.exports = new __parcel__URL__("shop_machines_technician_bunker_v2.7ddb99b6.png").toString();